export const MOTION_DURATION_MS = 500;

export const MOTION_EASE_CSS = 'cubic-bezier(0.22, 1, 0.36, 1)';

/** recharts 3 takes only named easings; same family as MOTION_EASE_CSS. */
export const MOTION_EASE_RECHARTS = 'ease-out';

const bezierComponent = (t: number, p1: number, p2: number): number =>
    3 * (1 - t) ** 2 * t * p1 + 3 * (1 - t) * t ** 2 * p2 + t ** 3;

/** Numeric evaluation of the `MOTION_EASE_CSS` curve: finds the bezier
 * parameter whose x matches `t` by bisection, then reads y off it. */
export const easeOut = (t: number): number => {
    if (t <= 0) return 0;
    if (t >= 1) return 1;

    let lower = 0;
    let upper = 1;
    let parameter = t;
    for (let i = 0; i < 30; i++) {
        parameter = (lower + upper) / 2;
        const x = bezierComponent(parameter, 0.22, 0.36);
        if (x < t) lower = parameter;
        else upper = parameter;
    }
    return bezierComponent(parameter, 1, 1);
};
